export const parseDate = (dateString) => {
    if (!dateString) return new Date(0);

    try {
        const str = String(dateString);
        // Extract all number groups
        const matches = str.match(/\d+/g);

        if (!matches || matches.length < 3) {
            // Fallback
            const d = new Date(str);
            return isNaN(d.getTime()) ? new Date(0) : d;
        }

        const nums = matches.map(n => parseInt(n, 10));

        // Find Year (usually 4 digits, e.g., 2024, 2025)
        // Look for a number > 1900 and < 2100
        let yearIndex = nums.findIndex(n => n > 1900 && n < 2200);

        let year, month, day;

        if (yearIndex !== -1) {
            year = nums[yearIndex];
            // Remove year from array to identify day/month from remaining
            nums.splice(yearIndex, 1);

            // Remaining 2 numbers are Day and Month
            // Usually first is Day, second is Month for TR locale (DD.MM)
            // But if we have MM/DD/YYYY format?
            // Let's assume DD.MM unless second number is > 12 (impossible for month)
            const n1 = nums[0];
            const n2 = nums[1];

            if (n2 > 12) {
                // n2 cannot be month, so n2 is day, n1 is month
                day = n2;
                month = n1 - 1;
            } else {
                // Standard DD.MM
                day = n1;
                month = n2 - 1;
            }
        } else {
            // No 4-digit year found? Maybe 2-digit year at the end?
            // Use original logic as fallback
            const p0 = parseInt(matches[0], 10);
            const p2 = parseInt(matches[2], 10);
            if (p0 > 31) { year = p0; month = parseInt(matches[1]) - 1; day = p2; }
            else { day = p0; month = parseInt(matches[1]) - 1; year = p2; }
        }

        if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
            // Final safety: ensure year is 4 digits if it was 2
            const fullYear = year < 100 ? 2000 + year : year;
            return new Date(fullYear, month, day);
        }

        return new Date(0);
    } catch (e) {
        console.error("Date parse error:", dateString, e);
        return new Date(0);
    }
};

export const sortEventsByDateDesc = (events) => {
    return [...events].sort((a, b) => {
        const dateA = parseDate(a.date);
        const dateB = parseDate(b.date);
        return dateB - dateA;
    });
};
